var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelaNaoEncontrado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 159.49 103.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#Gradiente_sem_nome_3-3);\n      }\n\n      .cls-3 {\n        fill: #20bfd5;\n      }\n\n      .cls-11 {\n        isolation: isolate;\n      }\n\n      .cls-4 {\n        fill: url(#Gradiente_sem_nome_3-2);\n      }\n\n      .cls-5 {\n        fill: #fdf5e6;\n      }\n\n      .cls-6 {\n        fill: #e5e5e5;\n      }\n\n      .cls-7 {\n        fill: #f08080;\n      }\n\n      .cls-8 {\n        fill: url(#Gradiente_sem_nome_4);\n      }\n\n      .cls-9 {\n        fill: url(#Gradiente_sem_nome_3);\n      }\n\n      .cls-10 {\n        fill: #1351b4;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3",
    "data-name": "Gradiente sem nome 3",
    x1: 7334.2,
    y1: -721.37,
    x2: 7323.56,
    y2: -739.19,
    gradientTransform: "translate(7348.63 -681.58) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5992ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155bcb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3-2",
    "data-name": "Gradiente sem nome 3",
    x1: 7308.89,
    y1: -683.31,
    x2: 7264.43,
    y2: -780.6,
    xlinkHref: "#Gradiente_sem_nome_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3-3",
    "data-name": "Gradiente sem nome 3",
    x1: 6375.17,
    y1: 9.7,
    x2: 6329.93,
    y2: -89.29,
    gradientTransform: "translate(3111.37 -5521.95) rotate(118.72)",
    xlinkHref: "#Gradiente_sem_nome_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_4",
    "data-name": "Gradiente sem nome 4",
    x1: 7195.97,
    y1: -734.04,
    x2: 7341.78,
    y2: -734.04,
    gradientTransform: "translate(7348.63 -681.58) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40e0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c5d4eb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_2-2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Camada_2-2",
    "data-name": "Camada 2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2-2",
    "data-name": "Camada 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fundo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cor",
    className: "cls-9",
    d: "M16.21,38.5c-6.79,3.62-9.62,13.08-4.46,22.37,1.29,2.33,3.29,3.87,5.25,3.42,4.58-.96,6.25-10.5,10.58-12.33,1.04-.46,2.21-.37,3.21-1.08,5.5-3.75-2.25-18.96-14.58-12.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-2",
    className: "cls-4",
    d: "M31.25,66.12c12.87,27.16,37.33,40.5,54.54,32.33,17.21-8.17,20.66-34.66,7.83-61.83C80.7,9.46,56.33-5.96,39.12,2.17c-17.21,8.17-20.75,36.79-7.87,63.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-3",
    className: "cls-2",
    d: "M88.07,103.07c30,1.79,59.03-13,60.16-32.04,1.12-19-22.29-35.87-52.29-37.66-30-1.79-55.24,12.25-56.37,31.25-1.12,19,18.5,36.7,48.49,38.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-4",
    className: "cls-8",
    d: "M135.19,8.58c-11.04-6.04-24.21-8.08-36.58-5.67-12.37,2.42-23.79,9.33-31.7,19.08-5.29,6.54-9.21,14.42-15.96,19.41-6.79,5.04-15.5,6.42-23.62,8.71-15.5,4.37-24.46,15.71-18.75,27.87,6.37,13.58,21.46,14.75,31.2,17.41,11.08,3,24.75,9.83,40.2,6.83,12.75-2.5,23.04-15.79,34.12-22.58,13.29-8.17,23.79-9.92,32.41-21.83,12.21-16.96,5.08-40.29-11.33-49.24h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "padroes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M151.19,61.95c-.29-.21-.33-.58-.12-.87.46-.67.96-1.33,1.37-2.04.17-.29.58-.37.87-.21s.37.58.21.87c-.46.71-.92,1.42-1.42,2.08-.12.17-.33.25-.5.25-.17.04-.29,0-.42-.08h0ZM154.65,56.41c-.29-.17-.42-.54-.29-.83.37-.75.71-1.5,1-2.25.12-.33.5-.46.83-.33.33.12.46.5.33.79-.33.79-.67,1.54-1.04,2.29-.12.21-.33.33-.54.33-.08.04-.21.04-.29,0ZM157.15,50.37c-.33-.08-.5-.46-.42-.79.21-.79.46-1.58.62-2.37.08-.33.42-.54.75-.46.33.08.54.42.46.75-.21.83-.42,1.62-.62,2.46-.08.29-.33.46-.58.46-.08,0-.17,0-.21-.04ZM158.57,44c-.33-.04-.58-.33-.54-.71.08-.79.17-1.62.21-2.42,0-.33.33-.62.67-.58.33,0,.62.33.58.67-.04.83-.12,1.67-.21,2.5-.04.33-.29.54-.62.54h-.08ZM158.23,36.91c-.04-.79-.08-1.62-.21-2.46-.04-.33.21-.67.54-.71s.67.21.67.54c.08.83.17,1.67.21,2.5,0,.33-.25.62-.58.67h-.04c-.29.04-.54-.21-.58-.54h0ZM157.4,30.54c-.04-.21-.08-.42-.12-.62-.12-.58-.29-1.17-.42-1.75-.08-.33.08-.67.42-.75s.67.12.75.46c.17.58.33,1.21.46,1.79.04.21.08.46.12.67.08.33-.17.67-.46.75h-.12c-.29-.04-.54-.25-.62-.54ZM155.61,24.37c-.29-.75-.58-1.54-.92-2.25-.12-.33,0-.67.33-.83s.67,0,.83.33c.33.75.67,1.54.96,2.33.12.33-.04.67-.37.79-.08.04-.17.04-.21.04-.29-.04-.54-.17-.62-.42h0ZM152.9,18.54c-.42-.71-.83-1.42-1.29-2.08-.21-.29-.12-.67.17-.87s.67-.12.87.17c.46.71.92,1.42,1.33,2.17.17.29.08.67-.25.83-.08.04-.21.08-.29.08-.25,0-.46-.08-.54-.29h0ZM149.27,13.21c-.5-.62-1.04-1.25-1.58-1.87-.25-.25-.21-.62.04-.87s.62-.21.87.04c.58.62,1.12,1.25,1.67,1.92.21.25.17.67-.08.87-.12.08-.25.12-.37.12-.25.04-.42-.04-.54-.21h0ZM144.86,8.58c-.62-.54-1.25-1.08-1.87-1.58-.25-.21-.33-.58-.12-.87.21-.25.62-.33.87-.12.67.5,1.29,1.04,1.96,1.62.25.21.29.62.04.87-.12.12-.29.21-.46.21-.17,0-.33-.04-.42-.12h0ZM139.69,4.75c-.67-.42-1.42-.83-2.12-1.21-.29-.17-.42-.54-.25-.83s.54-.42.83-.25c.75.37,1.46.83,2.17,1.25.29.17.37.58.21.87-.12.17-.33.29-.54.29-.04-.04-.17-.08-.29-.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M26.5,97.53c-.87-.17-1.67-.33-2.46-.54-.33-.08-.54-.42-.46-.75s.42-.54.75-.46c.75.17,1.54.33,2.42.5.33.08.54.37.5.75-.04.29-.33.5-.62.5-.04.04-.08.04-.12,0h0ZM20.08,95.95c-.83-.25-1.62-.54-2.37-.87-.33-.12-.46-.5-.33-.79s.5-.46.79-.33c.75.29,1.5.58,2.29.83.33.08.5.46.42.79-.08.25-.33.42-.58.42-.08-.04-.12-.04-.21-.04h0ZM13.96,93.32c-.75-.42-1.5-.87-2.17-1.33-.29-.21-.37-.58-.17-.87.21-.29.58-.37.87-.17.67.46,1.37.87,2.08,1.25.29.17.42.54.25.83-.12.21-.33.33-.54.33-.12.04-.21,0-.33-.04ZM8.54,89.45c-.62-.58-1.21-1.21-1.79-1.83-.25-.25-.21-.67.04-.87.25-.25.67-.21.87.04.54.58,1.08,1.17,1.71,1.75.25.25.25.62.04.87-.12.12-.29.21-.46.21-.12,0-.29-.04-.42-.17h0ZM4.29,84.33c-.46-.71-.87-1.46-1.29-2.21-.17-.29-.04-.67.25-.83s.67-.04.83.25c.37.71.79,1.42,1.21,2.12.17.29.08.67-.17.87-.08.08-.21.08-.33.08-.21,0-.37-.08-.5-.29ZM1.33,78.37c-.29-.79-.54-1.62-.71-2.46-.08-.33.12-.67.46-.75s.67.12.75.46c.17.79.42,1.54.67,2.33.12.33-.04.67-.37.79-.08.04-.12.04-.21.04-.25,0-.46-.17-.58-.42h0ZM.04,71.78c-.04-.37-.04-.75-.04-1.17,0-.46,0-.92.04-1.37.04-.33.33-.62.67-.58.33.04.62.33.58.67-.04.42-.04.87-.04,1.29,0,.37,0,.75.04,1.08,0,.33-.25.62-.58.67h-.04c-.33.04-.62-.25-.62-.58H.04Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "objeto03"
  }, /*#__PURE__*/React.createElement("g", {
    id: "objeto02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "objeto02-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cor-2-2",
    "data-name": "cor-2",
    className: "cls-6",
    d: "M130.82,37.71v53.66c0,.96-.79,1.75-1.75,1.75h-38.41c-.96,0-1.75-.79-1.75-1.75v-53.66c0-.96.79-1.75,1.75-1.75h38.41c.96.04,1.75.79,1.75,1.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-3-2",
    "data-name": "cor-3",
    className: "cls-10",
    d: "M130.82,37.71v8.21h-41.87v-8.21c0-.96.79-1.75,1.75-1.75h38.41c.92.04,1.71.79,1.71,1.75h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "objeto01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cor-4-2",
    "data-name": "cor-4",
    className: "cls-6",
    d: "M79.49,37.71v53.66c0,.96-.79,1.75-1.75,1.75h-38.41c-.96,0-1.75-.79-1.75-1.75v-53.66c0-.96.79-1.75,1.75-1.75h38.41c.96.04,1.75.79,1.75,1.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-5",
    className: "cls-10",
    d: "M79.49,45.91h-41.91v-8.21c0-.96.79-1.75,1.75-1.75h38.41c.96,0,1.75.79,1.75,1.75v8.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-6",
    className: "cls-3",
    d: "M79.49,37.71v8.21h-5.92v-8.21c0-.96-.79-1.75-1.75-1.75h5.92c.96.04,1.75.79,1.75,1.75Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "objeto01-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cor-7",
    className: "cls-5",
    d: "M105.95,84.99h-44.41c-1.12,0-2-.92-2-2V20.92c0-1.12.92-2,2-2h44.41c1.12,0,2,.92,2,2v62.08c.04,1.08-.87,2-2,2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-8",
    className: "cls-7",
    d: "M107.99,20.92v9.46h-48.45v-9.46c0-1.12.92-2,2-2h44.41c1.12-.04,2.04.87,2.04,2Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "objeto"
  }, /*#__PURE__*/React.createElement("g", {
    id: "detalhes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.87,59.58c-1.17-1-2.67-1.5-4.29-1.54h-.04c-1.62,0-3.12.54-4.29,1.5-.58.5-.67,1.37-.17,2,.5.58,1.37.67,2,.17.62-.54,1.54-.83,2.46-.83h0c.92,0,1.83.33,2.46.87.25.21.58.33.92.33.37,0,.79-.17,1.08-.5.54-.62.46-1.5-.12-2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.45,52.83h-.04c-.79,0-1.42.62-1.42,1.42,0,.75.54,1.33,1.29,1.42h.25c.71-.08,1.25-.67,1.25-1.42.04-.75-.58-1.37-1.33-1.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.12,52.83h0c-.79,0-1.42.62-1.42,1.42s.62,1.42,1.42,1.42h0c.79,0,1.42-.62,1.42-1.42,0-.79-.62-1.42-1.42-1.42h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.53,26.04h.12c.79,0,1.42-.62,1.42-1.42,0-.67-.46-1.25-1.12-1.37h-.42c-.71.08-1.25.67-1.25,1.42,0,.71.54,1.29,1.25,1.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.95,26.04c.79,0,1.42-.62,1.42-1.42s-.62-1.42-1.42-1.42h0c-.79,0-1.42.62-1.42,1.42s.62,1.42,1.42,1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.2,26.04c.79,0,1.42-.62,1.42-1.42s-.62-1.42-1.42-1.42h0c-.79,0-1.42.62-1.42,1.42s.67,1.42,1.42,1.42Z"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelaNaoEncontrado);
export default __webpack_public_path__ + "static/media/tela-nao-encontrado.786a1f2fc953b0dda860109ec67f93d5.svg";
export { ForwardRef as ReactComponent };